(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.SmsResubscribeController = (function(superClass) {
    extend(SmsResubscribeController, superClass);

    function SmsResubscribeController(scope, transitions, data, window, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.window = window;
      this.http = http;
      this.resubscribe = bind(this.resubscribe, this);
      SmsResubscribeController.__super__.constructor.call(this, 'sms_resubscribe', this.http);
      this.scope.title = 'SMS Resubscribe';
      this.scope.fullpage = true;
      this.scope.resubscribe = this.resubscribe;
      this.loadScopeData(this.data.getUnsubscribedSmses(), 'smses');
    }

    SmsResubscribeController.prototype.resubscribe = function(sms) {
      return this.data.resubscribeSms(sms.id).then((function(_this) {
        return function() {
          return _this.loadScopeData(_this.data.getUnsubscribedSmses(), 'smses');
        };
      })(this));
    };

    return SmsResubscribeController;

  })(AccessController);

}).call(this);
